class PushCartDiscount extends HTMLElement {
  constructor () {
    super()

    this.applyCoupon = this.applyCoupon.bind(this)
    this.removeCoupon = this.removeCoupon.bind(this)
  }

  connectedCallback () {
    this.initializeElements()
    this.setupEventListeners()
  }

  initializeElements () {
    this.inputEl = this.querySelector('[data-push-cart-discount-el="input"]')
    this.submitButton = this.querySelector('[data-push-cart-discount-el="submit"]')
    this.clearButton = this.querySelector('[data-push-cart-discount-el="clear"]')
    this.errorEl = this.querySelector('[data-push-cart-discount-el="error"]')
    this.errorMessage = this.errorEl.dataset.message || ''
  }

  setupEventListeners () {
    if (this.submitButton) {
      this.submitButton.addEventListener('click', this.applyCoupon)
    }

    if (this.clearButton) {
      this.clearButton.addEventListener('click', this.removeCoupon)
    }
  }

  busy () {
    this.clearError()
    this.setAttribute('busy', true)

    if (this.submitButton) {
      this.submitButton.setAttribute('disabled', true)
    }
  }

  done () {
    this.removeAttribute('busy')
    if (this.submitButton) {
      this.submitButton.removeAttribute('disabled')
    }
  }

  validateDiscount (code, cartData) {
    const check = cartData.discount_codes.filter(discountCode => {
      return discountCode.code === code && discountCode.applicable
    })

    return check.length > 0
  }

  async updateCart (code = '') {
    const formData = new FormData()
    formData.append('discount', code)

    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData
    })

    return await response.json()
  }

  async removeCoupon () {
    const cartData = await this.updateCart()
    this.publishUpdate(cartData)
  }

  publishUpdate (cartData) {
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'push-cart-discount',
      productVariantId: '',
      cartData,
    })

    this.done()
  }

  async applyCoupon () {
    const code = this.inputEl.value || ''

    if (!code) {
      return
    }

    this.busy()
    const cartData = await this.updateCart(code)

    if (this.validateDiscount(code, cartData)) {
      this.publishUpdate(cartData)
      return
    }

    this.handleError()
  }

  clearError () {
    this.errorEl.textContent = ''
    this.errorEl.setAttribute('aria-hidden', true)
  }

  handleError () {
    if (this.errorEl) {
      this.errorEl.textContent = `${this.errorMessage}`
      this.errorEl.removeAttribute('aria-hidden')
    }

    this.done()
  }

}

if (!customElements.get('push-cart-discount')) {
  customElements.define('push-cart-discount', PushCartDiscount)
}
